export default __webpack_public_path__ + "static/media/tickets.5e698356.png";